const GetStartedStyles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      backgroundColor: 'transparent', // Ensures no background edges
      width: '100%',
    },
    buttonContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '40px',
    },
    getStartedButton: {
      backgroundColor: '#81c241',
      color: '#fff',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      padding: '12px 25px',
      borderRadius: '8px',
      textTransform: 'none',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        backgroundColor: '#6aa832',
        transform: 'scale(1.05)',
      },
    },
    arrow: {
      width: '0',
      height: '0',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: '15px solid #000',
      marginTop: '10px',
    },
    heading: {
      fontWeight: 'bold',
      fontSize: '1.5rem',
      color: '#000',
      textAlign: 'left',
      width: '100%',
      maxWidth: '800px',
    },
    subheading: {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      color: '#000',
      textAlign: 'left',
      width: '100%',
      maxWidth: '800px',
      marginTop: '15px',
    },
    list: {
      width: '100%',
      maxWidth: '800px',
      paddingLeft: '15px',
      marginTop: '20px',
    },
    listItem: {
      fontSize: '1.1rem',
      color: '#333',
      marginBottom: '10px',
    },
    boldText: {
      fontWeight: 'bold',
    },
    disclaimer: {
      fontSize: '1rem',
      color: '#000',
      textAlign: 'left',
      width: '100%',
      maxWidth: '800px',
      marginTop: '30px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
  };
  
  export default GetStartedStyles;
  